import {DataFetcher} from '@aboutyou/data-fetcher';
import React, {FC} from 'react';
import {useReviewsSection} from '../../useGetProductBulkSection';
import {
  ReviewsSectionView,
  Props as ReviewsSectionViewProps,
} from './ReviewsSectionView.eager';
import {Skeleton} from './Skeleton';

export const ReviewsSection: FC<ReviewsSectionViewProps> = props => {
  return (
    <DataFetcher
      request={useReviewsSection()}
      Error={() => null}
      Loading={Skeleton}
      viewProps={props}
      View={ReviewsSectionView}
    />
  );
};
